import { InjectionToken } from '@angular/core';

// https://gist.github.com/inPhoenix/45a9f9e2568126d206f1125caebcd122
export const isEmpty = (value: any) => (
    value === null || // From standard.js: Always use === - but obj == null is allowed to check null || undefined
    value === void 0 ||
    (typeof value === 'object' && Object.keys(value).length === 0) ||
    (typeof value === 'string' && value.trim().length === 0)
);

export type isEmptyProvider = (value: any) => boolean;
export const IS_EMPTY = new InjectionToken('IS_EMPTY', {
    factory: () => isEmpty
});

